import { 
    EAuthorizationAuthorisedPersonOverviewRoute, 
    EAuthorizationEServiceRoute, 
    EAuthorizationEServicesGivenRightsRoute, 
    EAuthorizationEServicesReceiveRightsRoute, 
    EAuthorizationManagmentRoute, 
    EAuthorizationManagmentViewGrantedRightsRoute, 
    EAuthorizationManagmentViewReceivedRightsRoute, 
    EAuthorizationSubjectOverviewRoute 
} from "./routes.constant";

export const menuIsActAsModelRights = [
    EAuthorizationManagmentRoute,
    EAuthorizationEServiceRoute,
    EAuthorizationAuthorisedPersonOverviewRoute,
    EAuthorizationSubjectOverviewRoute
];

export const menuIsLegalRights = [
    EAuthorizationAuthorisedPersonOverviewRoute
];

export const menuIsPersonRights = [
    EAuthorizationSubjectOverviewRoute
];

export const menuIsCanOpenRecivedList = [
    EAuthorizationManagmentViewReceivedRightsRoute,
    EAuthorizationEServicesReceiveRightsRoute
];

export const menuIsCanOpenGivenList = [
    EAuthorizationEServicesGivenRightsRoute,
    EAuthorizationManagmentViewGrantedRightsRoute,
    EAuthorizationAuthorisedPersonOverviewRoute
]